import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { catchError, of, take, tap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../shared/services/shared.service';
import { ChatService } from '../../../shared/services/chat.service';
import { PopupComponent } from '../../../shared/components/popup/popup.component';

export interface question {
  value: number,
  icon: string,
  icon_text: string,
  question: string
}
@Component({
  selector: 'app-service-review',
  templateUrl: './service-review.component.html',
  styleUrls: ['./service-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceReviewComponent implements OnInit {
  serviceReviewDone: boolean = false;
  form!: FormGroup;
  isMobile: boolean = false;
  questions : question[] = [
    {
      value : 1,
      icon : "fa-face-frown-slight",
      icon_text : "Very unsatisfied",
      question : "Please tell us more about your experience so we can get it right the next time"
    },
    {
      value : 2,
      icon : "fa-face-raised-eyebrow",
      icon_text : "Unsatisfied",
      question : "Please tell us more about your experience so we can get it right the next time"
    },
    {
      value : 3,
      icon : "fa-face-meh",
      icon_text : "Neutral",
      question : "We would like to hear more about your experience"
    },
    {
      value : 4,
      icon : "fa-face-smile",
      icon_text : "Satisfied",
      question : "We are happy to hear. Tell us more about your experience."
    },
    {
      value : 5,
      icon : "fa-face-laugh",
      icon_text : "Very satisfied",
      question : "Great! We would like to hear more about your experience"
    }
  ]
  selectedTicket: any;
  @Input() set selectedTicketData(value: any) {
    this.selectedTicket = value;
    console.log(this.selectedTicket.ticketRatingSatisfaction);
    if(this.selectedTicket.ticketRatingSatisfaction) {
      setTimeout(() => {
        this.form?.patchValue({
          serviceReviewDate: new Date(this.selectedTicket.ticketRatingSatisfaction.createdAt),
          serviceReviewScore: this.selectedTicket.ticketRatingSatisfaction.score,
          serviceReviewQuestion: this.selectedTicket.ticketRatingSatisfaction.question,
          serviceReviewAnswer: this.selectedTicket.ticketRatingSatisfaction.answer
        })
        this.serviceReviewDone = true;
        this.form?.disable()
        this.cd.detectChanges()
      },100)
    }
    else {
      this.form?.patchValue({
        serviceReviewDate: new Date(),
        serviceReviewScore: null,
        serviceReviewQuestion: null,
        serviceReviewAnswer: null
      })
      this.serviceReviewDone = false;
      this.form?.enable()
    }
  }
  maxInputLength = 200;
  @ViewChild ('serviceReviewAnswerInput') serviceReviewAnswerInput!: ElementRef
  
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private chatService: ChatService,
  ) { 

  }

  ngOnInit() {
    this.isMobile = this.sharedService.isMobile;
    // this.questions = this.translate.instant('SERVICE_REVIEW.QUESTIONS')
    // console.log({questions: this.questions});
    
    this.initForm()
  }

  initForm(){
    this.form = this.fb.group({
      serviceReviewDate: this.fb.control(new Date()),
      serviceReviewScore: this.fb.control(null, Validators.required),
      serviceReviewQuestion: this.fb.control(null, Validators.required),
      serviceReviewAnswer: this.fb.control(null, [Validators.maxLength(this.maxInputLength)])
    })
  }

  get serviceReviewDate() {
    return this.form.controls['serviceReviewDate']
  }

  get serviceReviewScore() {
    return this.form.controls['serviceReviewScore']
  }

  get serviceReviewQuestion() {
    return this.form.controls['serviceReviewQuestion']
  }

  get serviceReviewAnswer() {
    return this.form.controls['serviceReviewAnswer']
  }

  setValue(question: any) {
    if(!this.serviceReviewDone) {
      if (this.serviceReviewScore.value === question.value) {
        this.serviceReviewScore.setValue(null);
        this.serviceReviewQuestion.setValue(null)
      }
      else {
        this.serviceReviewScore.setValue(question.value)
        const q: any = this.questions.find((e: any) => e.value === question.value)
        this.serviceReviewQuestion.setValue(q.question)
      }
      this.cd.detectChanges()
    }
  }

  submit() {
    if(this.form.valid) {
      const body = {
        ticketId: this.selectedTicket.id,
        ticketNumber: this.selectedTicket.ticketNumber,
        question: this.serviceReviewQuestion.value,
        answer: this.serviceReviewAnswer.value,
        score: this.serviceReviewScore.value
      }
      this.sharedService.changeMessage('loadingOn')
      this.chatService.setTicketRate(body).pipe(
        take(1),
        tap(() => {
          this.sharedService.changeMessage('loadingOff')
          this.openAlertModel('scoreSuccess')
        }),
        catchError(() => {
          this.sharedService.changeMessage('loadingOff')
          this.openAlertModel('scoreError')
          return of(null)
        })
      ).subscribe()
    }
  }

  openAlertModel(type: string) {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: this.isMobile ? '95%' : '400px',
      maxWidth: '95%',
      data: {
        type: type
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if(type === 'scoreSuccess') {
        this.serviceReviewDone = true;
        this.form.disable()
        this.cd.detectChanges()
      }
    })
  }

  onFocus(event?: any) {
    if(event) {
      this.serviceReviewAnswerInput.nativeElement.classList.add('focus');
    }
    else {
      this.serviceReviewAnswerInput.nativeElement.classList.remove('focus');
    }
    this.cd.detectChanges()
  }
}
